import { render, staticRenderFns } from "./ProviderServiceTable.vue?vue&type=template&id=7d50c646&scoped=true&"
import script from "./ProviderServiceTable.vue?vue&type=script&lang=js&"
export * from "./ProviderServiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d50c646",
  null
  
)

export default component.exports